"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.PressReleaseEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var constants_1 = require("../../constants");
var fields_1 = require("../../fields");
var document_factory_1 = require("./document-factory");
exports.PressReleaseEntity = document_factory_1.documentFactory(types_1.DocumentType.PRESS_RELEASE, function (prismicDoc, normalizedDoc, logger) {
    var _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var pressRelease = utils_1.compact(__assign(__assign({}, normalizedDoc), { title: logger.required(fields_1.toText((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.title)), description: fields_1.toText((_c = prismicDoc.data) === null || _c === void 0 ? void 0 : _c.description), thematic: logger.required(constants_1.toThematic((_d = prismicDoc.data) === null || _d === void 0 ? void 0 : _d.thematic, logger)), localization: constants_1.toLocalization((_e = prismicDoc.data) === null || _e === void 0 ? void 0 : _e.localization, logger) ||
            types_1.Localization.National, image: fields_1.toImage(prismicDoc.data.image_src, logger), related_article: fields_1.toLink((_f = prismicDoc.data) === null || _f === void 0 ? void 0 : _f.related_article, logger), publication_date: fields_1.toTimestamp((_g = prismicDoc.data) === null || _g === void 0 ? void 0 : _g.publication_date), release_date: fields_1.toTimestamp((_h = prismicDoc.data) === null || _h === void 0 ? void 0 : _h.release_date), link: fields_1.toLink((_j = prismicDoc.data) === null || _j === void 0 ? void 0 : _j.uri, logger), onFinance: fields_1.toBoolean((_k = prismicDoc.data) === null || _k === void 0 ? void 0 : _k.visible_finance, {
            defaultValue: false
        }), onNewsroom: fields_1.toBoolean((_l = prismicDoc.data) === null || _l === void 0 ? void 0 : _l.visible_newsroom, {
            defaultValue: true
        }), filters: utils_1.compact((_a = {},
            _a[types_1.Filter.Localization] = constants_1.toLocalization((_m = prismicDoc.data) === null || _m === void 0 ? void 0 : _m.localization, logger) ||
                types_1.Localization.National,
            _a[types_1.Filter.Thematic] = constants_1.toThematic((_o = prismicDoc.data) === null || _o === void 0 ? void 0 : _o.thematic, logger),
            _a)) }));
    return pressRelease;
});
//# sourceMappingURL=press-release.js.map